<template>
  <div
    ref="s_cont"
    :id="id + '_s'"
    :class="{ 
      disable: this.disable, 
      invalid: this.invalid, 
      'border-0': this.currs, 
      'backgroundless': backgroundless,
      'form-control-tall': this.keyt && this.keywords[this.name] && this.$store.state.resize.w < 768,
      'form-control-keyt': this.keyt,
      'form-control': !this.keyt,
    }"
    class="input-container d-flex flex-row align-items-center rounded8"
    tabindex="-1"
  >
    <div
      v-if="this.keyt && this.keywords[this.name]"
      v-on:click="(e) => this.showOpt(e)"
      class="input-container-select"
      style="overflow: hidden; padding-top: 0; padding-bottom: 0"
      :id="id"
    >
      <div class="m-0 neue-roman w-100" :class='{"mr-1": this.$store.state.resize.w > 767}'>
        <div class="d-flex w-100">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center w-100 gap-2">
            <div class="d-flex align-items-center justify-content-between" :class='{"pbp-10": this.$store.state.resize.w < 768}'>
              <div class="d-flex align-items-center">
                <div
                class="d-flex align-items-center mr8"
                >
                <div v-if="this.keywords[this.name].image">
                  <i
                    class="item-i contain c32 round-border"
                    :style="`background-image: url('${this.keywords[this.name].image}');`"
                  ></i>
                </div>
                <div v-else class="k-symbol">
                  <Icon name="default-curr" size="c32" />
                </div>
              </div>
              <div
                class="d-flex flex-column"
              >
                <div class="neue-roman d-flex flex-row fsp14 lhp20 neue text-black">
                  <span
                    v-if="this.keywords[this.name].identifier"
                    class="d-flex flex-row align-items-center"
                    :style="'white-space: nowrap'"
                  >
                    <span>
                      {{ this.getAliasString(this.keywords[this.name].identifier, true) }}
                    </span>
                  </span>
                  <span v-else :style="'white-space: nowrap'">
                    <span>
                      {{ this.getAliasString(this.keywords[this.name].code, true) }}
                    </span>
                  </span>
                </div>
                <span class="fsp12 lhp16 neue-roman primary-grey" :title="this.keywords[this.name].name">
                  {{ this.sizedName(this.keywords[this.name].value || this.keywords[this.name].name, true) }}
                </span>
              </div>
              </div>
              <div v-if="this.$store.state.resize.w < 768 && this.keywords[this.name]" class="c-arrow" @click="this.clickArrowSelect()">
                <Icon :name="showOptions ? 'chevron-up' : 'chevron-down'" class="c18 pe-none" stroke_width="3" />
              </div>
            </div>
            <div class="align-middle d-flex justify-content-between d-md-display" :class='{"ptp-16 border-t w-100": this.$store.state.resize.w <= 768, "max-w-40": this.$store.state.resize.w > 768}'>
              <span v-if="this.$store.state.resize.w < 768" class="neue fsp14 lh20 primary-grey">Balance</span>
              <span class="grid-cols-2">
                <span class="neue lh24 fsp16 mr8 text-black text-truncate" v-html="this.sizedBalance(this.keywords[this.name].balance)"></span>
                <span class="fsp16 lhp24 neue primary-grey text-truncate">{{ this.keywords[this.name].curr }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.$store.state.resize.w > 768 || !this.keywords[this.name]" class="c-arrow" @click="this.clickArrowSelect()">
        <Icon :name="showOptions ? 'chevron-up' : 'chevron-down'" class="c18 pe-none" stroke_width="3" />
      </div>
    </div>
    <Popper
      v-else-if="this.currs"
      :automaticOpen="true"
      :show="invalid && invalidHint"
      :minWidthAuto="true"
      :offsetY="-10"
      :offset="'25%'"
      :invalid="!!invalid"
      class="w-100"
    >
      <div  v-on:click="(e) => this.showOpt(e)" class="input-container-select p-0" :class="{ 'fsp16': this.$store.state.resize.w <= 768, 'fsp20': this.$store.state.resize.w > 768 }" :id="id">
        <div v-if="this.toggleIcons" class="curr-icon c40 mrp-10">
          <img v-if="this.name.icon" :src="this.name.icon" alt="">
          <Icon v-else name="default-curr" size="c40" />
        </div>
        <span
          class="input-container-select-value d-flex align-items-center flex-grow-1 fw-medium neue mr8 neue"
          v-if="!this.isFilterSelect"
          :class="{ grey: this.name.g }"
        >
          <span class="text-truncate lh28" :class="{ 'primary-grey': !this.name?.n, 'text-black': this.name?.n }">{{ this.name?.n ? this.name.n : this.defaultValue }}</span>
          <span v-if="this.value" class="primary-stroke" :class="this.$store.state.resize.w <= 768 ? 'mx8': 'mx12'">|</span>
          <span class="primary-grey">{{ this.getTotalAssets(this.value, true) }}</span>
        </span>
        <span
          class="input-container-select-value d-flex align-items-center flex-grow-1 fw-medium neue mr8 neue"
          v-else
          v-show="!this.isSearch || !this.showOptions"
          :class="{ grey: !this.name?.n }"
        >
          <span class="text-truncate lh28" :class="{ 'primary-grey': !this.name?.n, 'text-black': this.name?.n }">{{ this.name?.n ? this.name.n : this.defaultValue }}</span>
          <span v-if="this.value" class="mx12 primary-stroke">|</span>
          <span class="primary-grey">{{ this.getTotalAssets(this.value, true) }}</span>
        </span>
        <div v-if="!this.name.n || !this.isFilterSelect" class="c-arrow" @click="this.clickArrowSelect()">
          <Icon :name="showOptions ? 'chevron-up' : 'chevron-down'" class="c24 pe-none" stroke_width="3" />
        </div>
        <div
          v-else-if="this.name.n && this.isFilterSelect && (!this.isSearch || !this.showOptions)"
          @click="this.clearFilterSelect()"
        >
          <i class="item-i remove-val c20"></i>
        </div>
      </div>
      <template #content>
        <div :id="this.id + '-invalid'">{{ this.invalidHint }}</div>
      </template>
    </Popper>
    <Popper
      v-else-if="this.currsP2P"
      :automaticOpen="true"
      :show="invalid && invalidHint"
      :minWidthAuto="true"
      :offsetY="-10"
      :offset="'25%'"
      :invalid="!!invalid"
      class="w-100"
    >
      <div v-on:click="(e) => this.showOpt(e)" class="input-container-select fsp14" :id="id">
        <Icon v-if="icon" :color="processedIconColor" :name="icon" class="icon-left c16 mr8" />
        <div class="d-flex align-items-center fw-medium flex-grow-1">
          <div v-if="this.name?.n" class="mrp-8 flex-shrink-0 curr-icon c16">
            <img v-if="this.name.logo" :src="this.name.logo" />
            <Icon v-else name="default-curr" size="c16" />
          </div>
          <div class="d-flex justify-content-between flex-grow-1 overflow-hidden" style="max-width: 100%;">
            <span class="d-flex align-items-center overflow-hidden fsp14 lh20 neue" :class="{ 'primary-grey': !this.name?.n || this.disable, 'text-black': this.name?.n && !this.disable }">
              {{ this.name?.n ? this.truncateCurrName(this.name?.full_name || this.name?.name, 20) : this.defaultValue }}
            </span>
            <span v-if="this.name?.n" class="primary-grey fsp12 lh20 mrp-12">
              {{ this.truncateCurrName(this.currsP2P == 'internal' ? this.name.small_name : (this.name.curr_text || this.name.unit_abbreviation), 7) }}
            </span>
          </div>
        </div>
        <div
          v-if="this.name?.n && this.isFilterSelect && (!this.isSearch || !this.showOptions)"
          @click.stop="this.clearFilterSelect()"
        >
          <Icon name="close" class="c16" />
        </div>
        <div class="c-arrow ml8" @click="this.clickArrowSelect()">
          <Icon :name="showOptions ? 'chevron-up' : 'chevron-down'" class="c18 pe-none" stroke_width="3" />
        </div>
      </div>
      <template #content>
        <div :id="this.id + '-invalid'">{{ this.invalidHint }}</div>
      </template>
    </Popper>
    <Popper
      v-else
      :automaticOpen="true"
      :show="invalid && invalidHint"
      :minWidthAuto="true"
      :offsetY="-10"
      :offset="'25%'"
      :invalid="!!invalid"
      class="w-100"
    >
      <div v-on:click="(e) => this.showOpt(e)" class="input-container-select fsp14" :id="id">
        <Icon v-if="icon" :color="processedIconColor" :name="icon" class="icon-left c16 mr8" />
        <div v-if="this.toggleIcons && this.iconName" class="mr8">
          <Icon :name="this.iconName" size="c20" />
        </div>
        <div v-if="!this.showOptions && this.name.icon && this.toggleIcons" class="curr-icon mrp-10"><img :src="this.name.icon" alt=""></div>
        <span
          class="input-container-select-value flex-grow-1 mr4 neue fw-medium"
          v-if="!this.isFilterSelect && !this.hideLabel"
          v-html="this.name?.n ? this.name.n : this.defaultValue"
          :class="{ 'primary-grey': !this.name?.n || this.disable, 'text-black': this.name?.n && !this.disable }"
        ></span>
        <span
          class="input-container-select-value flex-grow-1 mr8 neue fw-medium"
          v-else-if="!this.hideLabel"
          v-html="this.name?.n ? this.name.n : this.defaultValue"
          :class="{ 'primary-grey': !this.name?.n || this.disable, 'text-black': this.name?.n && !this.disable }"
        ></span>
        <div
          v-if="this.name.n && this.isFilterSelect && (!this.isSearch || !this.showOptions)"
          @click.stop="this.clearFilterSelect()"
        >
          <Icon name="close" class="c16" />
        </div>
        <div class="c-arrow d-flex align-items ml8" @click="this.clickArrowSelect()">
          <Icon :name="showOptions ? 'chevron-up' : 'chevron-down'" class="c18 pe-none" stroke_width="3" />
        </div>
      </div>
      <template #content>
        <div :id="this.id + '-invalid'">{{ this.invalidHint }}</div>
      </template>
    </Popper>

    <transition v-if="this.keyt" @enter="enter" @leave="leave">
      <div
        ref="o_cont"
        :class="this.transformUp ? 'open-up' : ''"
        :style="!this.transformUp ? 'max-height: ' + this.listHeight + 'px; top: 100%;' : 'top: 0;'"
        v-if="showOptions && !disable"
        class="p-3 input-container-select-options border-top border-1 border-grey keyt-options rounded8"
      >
        <div class="mtp-10">
          <span v-if="this.isSearch" v-show="this.showOptions" class="input-search-wrapper mb12">
            <span class="d-flex justify-content-center align-items-center">
              <Icon name="search-select" class="c16 mr8" />
            </span>
            <input class="input-search flex-grow-1 pr-1" ref="input_search" type="text" @input="inputSearchHandler" tabindex="-1" placeholder="Search..."/>
            <div @click.stop="this.clearSearchInput">
              <Icon v-if="this.textInSearch" name="clear-search" class="pe-none c16 d-flex justify-content-center align-items-center" />
            </div>
          </span>
        </div>
        <div v-if="this.keywords.length > 0" class="m-0 neue-roman">
          <div :style="'max-height: ' + this.listHeight + 'px;'" class="d-flex flex-column">
            <div
              class="d-flex flex-column flex-sm-row justify-content-between align-items-md-center border-top border-grey py12"
              v-for="row in this.optionsList"
              :key="row.code"
              :id="'c-ss-k-'+row.code"
              v-on:click="
                () => {
                  this.selectOption(row.code);
                }
              "
            >
              <div class="d-flex align-items-md-center">
                <div
                  class="align-middle mr8"
                >
                  <div v-if="row.image">
                    <i class="item-i contain c32 round-border" :style="`background-image: url('${row.image}');`"></i>
                  </div>
                  <div v-else class="k-symbol">
                    <Icon name="default-curr" size="c32" />
                  </div> 
                </div>
                <div class="align-middle">
                  <div class="neue-roman d-flex flex-row fsp14 lhp20 neue text-black">
                    <span
                      v-if="row.identifier"
                      class="d-flex flex-row align-items-center"
                      :style="'white-space: nowrap'"
                    >
                      <span>
                        {{ this.getAliasString(row.identifier) }}
                      </span>
                    </span>
                    <span v-else :style="'white-space: nowrap'">
                      <span>
                        {{ this.getAliasString(row.code) }}
                      </span>
                    </span>
                  </div>
                  <div class="fsp12 lhp16 neue-roman primary-grey" :style="'white-space: nowrap'">
                    {{ this.sizedName(row.value || row.name) }}
                  </div>
                </div>
              </div>
              <div class="align-middle d-flex justify-content-between d-md-display grid-cols-2" :class='{"pl40 w-100": this.$store.state.resize.w < 768, "max-w-40": this.$store.state.resize.w > 768}'>
                <span class="neue lh24 fsp16 mr8 text-black text-truncate" v-html="this.sizedBalance(row.balance)"></span>
                <span class="fsp16 lhp24 neue primary-grey text-truncate">{{ row.curr }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition v-else-if="currs" @enter="enter" @leave="leave">
      <ul
        ref="o_cont"
        class="input-container-select-options border-shadow"
        :class="this.transformUp ? 'open-up' : ''"
        :style="!this.transformUp ? 'max-height: ' + this.listHeight + 'px; top: 120%;' : 'top: 0;'"
        v-if="showOptions && !disable && isSearch"
      > 
        <div class="position-sticky top-0 left-0 px12 py16 bg-white">
          <span v-if="this.isSearch" v-show="this.showOptions" class="input-search-wrapper">
            <input class="input-search flex-grow-1 pr-1" ref="input_search" type="search" @input="inputSearchHandler" tabindex="-1" />
          </span>
        </div>
        <li
          class="input-container-select-options-li d-flex align-items-center justify-content-between pointer mx12 border-t py12 pl-0 pr-0"
          v-for="option in this.optionsList"
          :id="'c-ss-i-'+ option.code"
          :key="option.code"
          :class="{ acted: this.value == option.code }"
          v-on:click="() => { this.selectOption(option.code) }"
        >
          <div class="d-flex align-items-center fw-medium option-left-content flex-grow-1">
            <div v-if="toggleIcons" class="mr10 flex-shrink-0 curr-icon c40">
              <img v-if="option.icon" :src="option.icon" />
              <Icon v-else name="default-curr" size="c40" />
            </div>
            <div class="d-flex justify-content-between flex-grow-1 overflow-hidden" :class="{ 'd-block flex-column': this.$store.state.resize.w <= 768}" style="max-width: 100%;">
              <span class="d-flex align-items-center overflow-hidden">
                <span v-html="option.value || option.name" class="option-name text-truncate neue"></span>
                <span class="primary-stroke neue flex-shrink-0" :class="this.$store.state.resize.w <= 768 ? 'mx8' : 'mx12'">|</span>
                <span class="primary-grey neue text-nowrap flex-shrink-0">{{ this.getTotalAssets(option) }}</span>
              </span>
              <div 
                class="HelveticaNeue option-balance-container" 
                :class="this.$store.state.resize.w > 768 && 'text-end'"
                v-html="this.sumMask(String(option.balance))"
              />
            </div>
          </div>
        </li>
      </ul>
      <ul
        ref="o_cont"
        class="input-container-select-options"
        :class="this.transformUp ? 'open-up' : ''"
        :style="!this.transformUp ? 'max-height: ' + this.listHeight + 'px; top: 43px;' : 'top: 0;'"
        v-else-if="showOptions && !disable"
      >
        <li
          class="input-container-select-options-li"
          v-for="keyword in this.keywords"
          :key="keyword.code"
          :id="'c-ss-i-'+ keyword.code"
          :class="{ acted: this.value == keyword.code }"
          v-on:click="() => { this.selectOption(keyword.code) }"
        >
          <label v-html="keyword.value || keyword.name"></label>
        </li>
      </ul>
    </transition>
    <transition v-else-if="this.currsP2P" @enter="enter" @leave="leave">
      <ul
        ref="o_cont"
        class="input-container-select-options border-shadow"
        :class="this.transformUp ? 'open-up' : ''"
        :style="!this.transformUp ? 'max-height: ' + this.listHeight + 'px; top: 120%;' : 'top: 0;'"
        v-if="showOptions && !disable && isSearch"
      > 
        <div class="position-sticky top-0 left-0 px12 py16 bg-white">
          <span v-if="this.isSearch" v-show="this.showOptions" class="input-search-wrapper">
            <input class="input-search flex-grow-1 pr-1" ref="input_search" type="search" @input="inputSearchHandler" tabindex="-1" />
          </span>
        </div>
        <li
          class="input-container-select-options-li d-flex align-items-center justify-content-between pointer mx12 border-t py12 pl-0 pr-0"
          v-for="option in this.optionsList"
          :id="'c-ss-i-'+ option.code"
          :key="option.code"
          :class="{ acted: this.value == option.code }"
          v-on:click="() => { this.selectOption(option.code) }"
        >
          <div class="d-flex align-items-center fw-medium option-left-content flex-grow-1">
            <div class="mrp-8 flex-shrink-0 curr-icon c24">
              <img v-if="option.logo" :src="option.logo" />
              <Icon v-else name="default-curr" size="c24" />
            </div>
            <div class="d-flex justify-content-between flex-grow-1 overflow-hidden" style="max-width: 100%;">
              <span class="d-flex align-items-center overflow-hidden fsp14 lh20 neue">
                {{ this.truncateCurrName(option.full_name ? option.full_name : option.name, 20) }}
              </span>
              <span class="primary-grey fsp12 lh20">
                {{ this.truncateCurrName(this.currsP2P == 'internal' ? option.small_name : (option.curr_text || option.unit_abbreviation), 7) }}
              </span>
            </div>
          </div>
        </li>
      </ul>
      <ul
        ref="o_cont"
        class="input-container-select-options"
        :class="this.transformUp ? 'open-up' : ''"
        :style="!this.transformUp ? 'max-height: ' + this.listHeight + 'px; top: 43px;' : 'top: 0;'"
        v-else-if="showOptions && !disable"
      >
        <li
          class="input-container-select-options-li"
          v-for="keyword in this.keywords"
          :key="keyword.code"
          :id="'c-ss-i-'+ keyword.code"
          :class="{ acted: this.value == keyword.code }"
          v-on:click="() => { this.selectOption(keyword.code) }"
        >
          <label v-html="keyword.value || keyword.name"></label>
        </li>
      </ul>
    </transition>
    <transition v-else @enter="enter" @leave="leave">
      <ul
        ref="o_cont"
        class="input-container-select-options border-top border-1 border-grey list-search"
        :class="{ 'open-up': this.transformUp, 'open-left' : this.transformLeft, relative: !this.floating }"
        :style="{'max-height':  !this.transformUp && this.listHeight + 'px', 'top': !this.transformUp ? '115%' : '0', 'width': this.listWidth ? this.listWidth + 'px' : 'auto'}"
        v-if="showOptions && !disable && isSearch"
      >
        <div class="mtp-10">
          <span v-if="this.isSearch" v-show="this.showOptions" class="input-search-wrapper mb12">
            <span class="d-flex justify-content-center align-items-center">
              <Icon name="search-select" class="c16 mr8" />
            </span>
            <input class="input-search flex-grow-1 pr-1" ref="input_search" type="text" @input="inputSearchHandler" tabindex="-1" placeholder="Search..."/>
            <div @click.stop="this.clearSearchInput">
              <Icon v-if="this.textInSearch" name="clear-search" class="pe-none c16 d-flex justify-content-center align-items-center" />
            </div>
          </span>
        </div>
        <li
          class="input-container-select-options-li justify-content-between fsp14"
          v-for="option in this.optionsList"
          :id="'c-ss-i-'+ option.code"
          :key="option.code"
          :class="{ acted: this.value == option.code, 'd-flex align-items-center': toggleIcons }"
          v-on:click="() => { this.selectOption(option.code) }"
        >
          <div v-if="toggleIcons && option.icon" class="mrp-10 curr-icon"><img :src="option.icon" /></div>
          <label v-html="option.value || option.name" class="text-nowrap overflow-hidden text-truncate"></label>
        </li>
      </ul>
      <ul
        ref="o_cont"
        class="input-container-select-options"
        :class="{ 'open-up': this.transformUp, 'open-left' : this.transformLeft }"
        :style="{'max-height': !this.transformUp ? this.listHeight + 'px' : '', 'top': !this.transformUp ? '43px' : '0', 'width': this.listWidth ? this.listWidth + 'px' : 'auto'}"
        v-else-if="showOptions && !disable"
      >
        <li
          class="input-container-select-options-li fsp14"
          v-for="keyword in this.keywords"
          :key="keyword.code"
          :id="'c-ss-i-'+ keyword.code"
          :class="{ acted: this.value == keyword.code }"
          v-on:click="
            () => {
              this.selectOption(keyword.code);
            }
          "
        >
          <label v-html="keyword.value || keyword.name"></label>
        </li>
      </ul>
    </transition>
    <!-- <div v-if="this.invalidHint && this.invalid" class="invalid-tooltip" :id="this.id + '-invalid'">
      {{ this.invalidHint }}
    </div> -->
  </div>
</template>

<script>
import { gsap } from "gsap";
import InputSimple from "@/components/service/InputSimple";
import { escapeHtml } from "@vue/shared";
import Icon from '@/components/icons/Icon.vue';
import Popper from '@/components/service/Popper.vue';

export default {
  components: {
    InputSimple,
    Icon,
    Popper
  },
  data() {
    return {
      value: this.dataValue ? this.dataValue : "",
      showOptions: false,
      name: this.dataValue ? this.getOption(this.dataValue) : "",
      listHeight: "200",
      transformUp: false,
      transformLeft: false,
      elemWidth: false,
      optionsList: [],
      isSetValue: false,
      arrowClick: false,
      textInSearch: ''
    };
  },
  props: {
    id: [String, Boolean],
    keywords: [Array, String, Boolean],
    dataValue: [String, Number, Boolean],
    invalid: [Boolean],
    invalidHint: [String],
    keyt: {
      default: false,
      type: [Boolean],
    },
    currs: {
      default: false,
      type: [Boolean]
    },
    currsP2P: {
      default: false,
      type: [Boolean, String]
    },
    hotUpdate: {
      default: false,
      type: [Boolean],
    },
    disable: {
      default: false,
      type: [Boolean],
    },
    isSearch: {
      default: false,
      type: [Boolean],
    },
    defaultValue: {
      default: "",
      type: [String],
    },
    isFilterSelect: {
      default: false,
      type: [Boolean],
    },
    floating: {
      // Когда true — dropdown рендерится overlay-ом (position: absolute из базового CSS)
      // с внутренним скроллом по max-height, вместо встраивания в поток (class="relative").
      // Нужно для длинных списков внутри модалок, чтобы не расширять саму модалку.
      default: false,
      type: [Boolean],
    },
    isPaginationSelect: {
      default: false,
      type: [Boolean],
    },
    searchType: {
      default: "value",
      type: [String],
      Required: false,
    },
    toggleIcons: {
      default: false,
      type: Boolean,
    },
    backgroundless: {
      type: [Boolean],
      default: false
    },
    listWidth: {
      default: false,
      type: [Number, Boolean],
    },
    maxListHeight: {
      default: false,
      type: [Number, Boolean],
    },
    hideLabel: {
      default: false,
      type: [Boolean],
    },
    iconName: {
      type: [String, Boolean],
      default: false
    },
    icon: {
      type: [String, Boolean],
      default: false
    },
    iconColor: {
      type: [Boolean, Object],
      default: false,
    }
  },
  computed: {
    processedIconColor() {
      if (!this.iconColor) return false;
      if (typeof this.iconColor === 'string') return this.iconColor;
      if (typeof this.iconColor === 'object') {

        return Object.values(this.iconColor)[0] || false;
      }
      return false;
    }
  },
  mounted() {
    console.log('mounted select simple', this.isSearch);
    // new ResizeObserver(outputsize).observe(this.$refs.s_cont),
    this.elemWidth = this.$refs.s_cont.offsetWidth;
    this.optionsList = this.keywords && this.keywords.length > 0 ? [...this.keywords] : [];
    // console.log('mounted value', this.value);
    // Апдейт значения в aml селекте, при повторе операции
    if(this.$route.query.fields && this.keywords.length && this.keywords[0].alias === 'alias_sender_aml_level') {
      const amlItem = this.keywords.find(keyword => {
        return JSON.parse(this.$route.query.fields).find(field => field.value == keyword.value)
      })
      if(amlItem) {
          this.selectOption(amlItem.code)
          this.$emit('updateParentState', {
              id: this.id,
              value: amlItem.code
          })
      }
    }
  },
  beforeUnmount() {
    document.querySelector("body").removeEventListener("click", this.clickClose);
    // Убираем класс с родительской модалки на случай, если dropdown был открыт
    // в момент уничтожения компонента.
    this._toggleModalOverflow(false);
  },
  watch: {
    dataValue(newV, oldV) {
      if (this.hotUpdate) {
        this.selectOption(newV, true);

        // console.log('watch selectSimple newV', newV);
      }
    },
    keywords(newV) {
      if (newV && newV.length) {
        this.optionsList = [...newV];
      }
      if(this.value && newV.length) {
        this.selectOption(this.value, true);
      }
    },
    showOptions(isOpen) {
      // При floating=true на время открытого dropdown снимаем overflow:auto
      // с родительской .vue-modal-window — иначе absolute-dropdown учитывается
      // в scrollHeight и модалка начинает требовать прокрутку.
      // Для не-floating селектов поведение не меняется.
      if (!this.floating) return;
      this._toggleModalOverflow(isOpen);
    },
  },
  methods: {
    // obs_call() {
    //     this.elemWidth = this.$refs.s_cont.offsetWidth;
    // },
    clickArrowSelect() {
      console.log('clickArrowSelect', this.showOptions);
      //this.arrowClick = true;
      // if (this.showOptions) {
      //   this.closeSelect();
      //   this.arrowClick = true;
      // }
    },
    searchInList(arg) {
      if (!this.keywords) {
        return;
      }
    },
    getTotalAssets(value, valueIsTicker = false) {
      if(value) {
        let keyword = value;
  
        if(valueIsTicker) {
          keyword = this.keywords.find(keyword => keyword.code === value)
        }
  
        if(!keyword) {
          if(!this.keywords || !this.keywords.length) return
          keyword = this.keywords[0]
          this.value = this.keywords[0].code
          this.updateState()
        }
  
        let assetsNum = this.$store.getters.get_sort_keyts.filter(keyts => keyts.curr_code === keyword.curr_code).length

        if(assetsNum >= 1000) {
          assetsNum = this.$lib.formatNum(this, assetsNum , 0)
        }

        return assetsNum === 1 ? `${assetsNum} ${this.$t('views.Home.57')}` : `${assetsNum} ${this.$t('views.Home.58')}`
      }
    },
    sumMask(sum) {
      let arr = sum.split('.');
      //if (arr[0].length > 9) {
      //  let humVal = this.$lib.bignumberToHumanValue(arr[0]);
      //  return `<span  class=' neue text-black' :class="this.$store.state.resize.w <= 768 ? 'fsp16' : 'fsp20'">${humVal[0]} ${humVal[1]}</span>`
      //}
      let classList = this.$store.state.resize.w <= 768 ? 'fsp16' : 'fsp20';
      let classList2 = this.$store.state.resize.w <= 768 ? 'fsp12' : 'fsp14';
      if (arr[1]) {
        return `<span class="${classList} neue text-black">${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class="${classList2} neue primary-grey">.${arr[1]}</span>`
      } else {
        return `<span class="${classList} neue text-black">${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
      }
    },
    getSizedAlias(str, firstLength, lastLength) {
      let s = str.substring(0, firstLength);
      s += "...";
      s += str.substring(str.length - lastLength);
      return s;
    },
    getAliasString(str, header=false) {
      if (this.elemWidth && this.elemWidth > 400 && this.elemWidth < 768 && str && str.length > 20) {
        return header ? this.getSizedAlias(str, 8, 6) : this.getSizedAlias(str, 16, 4);
      } else if (this.elemWidth && this.elemWidth > 300 && this.elemWidth < 400 && str && str.length > 16) {
        return this.getSizedAlias(str, 10, 4);
      } else if (this.elemWidth && this.elemWidth < 300 && str && str.length > 8) {
        return this.getSizedAlias(str, 2, 4);
      } else if (str && str.length > 20) {
        return this.getSizedAlias(str, 16, 4);
      }
      return str;
    },
    sized(str) {
      if (this.elemWidth && this.elemWidth < 400 && str.length > 7) {
        return this.$lib.getTokenString(str, 4);
      } else if (this.elemWidth && this.elemWidth < 500 && str.length > 20) {
        return this.$lib.getTokenString(str, 8);
      } else if (this.elemWidth && this.elemWidth < 700 && str.length > 30) {
        return this.$lib.getTokenString(str, 12);
      } 
      return str;
    },
    sizedName(str, header=false) {
      if (!str) {
        return "";
      }
      if (typeof str === 'object') {
        str = str.en || str.ru || Object.values(str)[0] || '';
      }
      str = String(str);
      if (this.elemWidth && this.elemWidth > 400 && this.elemWidth < 768 && str && str.length > 20) {
        return str.substring(0, 20) + '...';
      } else if (this.elemWidth && this.elemWidth > 300 && this.elemWidth < 400 && str && str.length > 16) {
        return str.substring(str, 10) + '...';
      } else if (this.elemWidth && this.elemWidth < 300 && str && str.length > 8) {
        return str.substring(str, 3) + '...';
      } else if (str && str.length > 20) {
        return str.substring(str, 16) + '...';
      }
      return str;
    },
    sizedBalance(str) {
      if (!str) {
        return "";
      }
      let arr = str.split(".");
      if (arr.length == 1) {
        return this.$lib.getFormattedNumber(str);
      } else {
        if (arr[1].length > 8) {
          arr[1] = arr[1].substring(0, 8);
        }
        return this.$lib.getFormattedNumber(arr[0]) + `.<span class="fsp12 lhp21 neue primary-grey">${arr[1]}</span>`;
      }
    },
    truncateCurrName(name, maxLength = 20) {
      if (!name) return name;
      if (typeof name === 'object') {
        name = name.en || name.ru || Object.values(name)[0] || '';
      }
      name = String(name);
      if (name.length <= maxLength) {
        return name;
      }
      return name.substring(0, maxLength) + '...';
    },
    updateState(repeat = false) {
      this.$emit("updateParentState", {
        id: this.id,
        value: this.value,
        repeat: repeat,
      });
      this.blur();
    },
    setValue(repeat = false) {
      this.updateState(repeat);

      this.isSetValue = true;
    },
    blur() {
      this.$emit("blurInput", {
        id: this.id,
        value: this.value,
      });
    },
    sortArr() {
      let arr = this.keywords;
      arr.sort((r1, r2) => {
        if (r1.code != this.value && r2.code != this.value) {
          return 0;
        }
        if (r1.code == this.value && r2.code != this.value) {
          return -1;
        }
        if (r1.code != this.value && r2.code == this.value) {
          return 1;
        }
      });
      // console.log(arr);
    },
    showOpt() {
      console.log('showOpt', this.showOptions);
      // if (this.arrowClick) {
      //   this.arrowClick = false;
      //   return;
      // }

      if (this.disable) {
        this.showOptions = false;
        document.querySelector("body").removeEventListener("click", this.clickClose);
        return;
      }
      // this.sortArr();

      if (this.isSearch) {
        this.optionsList = this.keywords && this.keywords.length > 0 ? [...this.keywords] : [];
      }

      this.setListPosition();

      //if (!this.isSearch || (this.isSearch && !this.showOptions)) {
      this.showOptions = !this.showOptions;
      //}

      this.showOptions ? this.$refs.s_cont.focus() : this.$refs.s_cont.blur();
      document.querySelector("body").addEventListener("click", this.clickClose);

      if (this.isSearch && this.showOptions && this.$refs.input_search) {
        this.$refs.input_search.focus();
      }

      this.$nextTick(() => {
        if (this.$refs.input_search) {
          this.$refs.input_search.focus();
        }
        if (this.showOptions && this.$refs.o_cont) {
          this.resetScrollToTop();
          if(this.listWidth) {
            this.calculateListPosition();
          }
        }
      });

      console.log('showOptions', this.showOptions);
    },
    resetScrollToTop() {
      if (this.$refs.o_cont) {
        this.$refs.o_cont.scrollTop = 0;
      }
    },
    getHeight() {
      return window.innerHeight - this.$refs.s_cont.getBoundingClientRect().bottom - 10;
    },
    setListPosition() {
      const rect = this.$refs.s_cont.getBoundingClientRect();
      const availableBelow = Math.max(0, window.innerHeight - rect.bottom - 10);
      const availableAbove = Math.max(0, rect.top - 10);
      const preferredHeight = this.maxListHeight || 280;

      this.transformUp = availableBelow < preferredHeight && availableAbove > availableBelow;
      const availableHeight = this.transformUp ? availableAbove : availableBelow;
      this.listHeight = Math.min(availableHeight, preferredHeight);
    },
    calculateListPosition() {
      if (!this.$refs.s_cont) return;
      
      const containerRect = this.$refs.s_cont.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const containerLeft = containerRect.left;
      const windowWidth = window.innerWidth;
      
      let listWidth = containerWidth;
      if (this.listWidth) {
        listWidth = this.listWidth;
      }
      
      const rightEdge = containerLeft + listWidth;
      if (rightEdge > windowWidth) {
        const overflow = rightEdge - windowWidth;
        const leftEdge = containerLeft - overflow;
        
        if (leftEdge >= 0) {
          this.transformLeft = true;
          return overflow;
        } else {
          this.transformLeft = true;
          return containerLeft - 10;
        }
      } else {
        this.transformLeft = false;
        return 0;
      }
    },
    clearSearchInput() {
      if (this.$refs.input_search) {
        this.$refs.input_search.value = "";
      }

      this.textInSearch = false;
    },
    closeSelect() {
      this.showOptions = false;
      document.querySelector("body").removeEventListener("click", this.clickClose);

      // метод содержит проверку наличия инпута поиска и его очистку
      this.clearSearchInput();
    },
    clickClose(e) {
      console.log('clickClose', this.showOptions);
      if (!this.$el.contains(e.target) && !this.arrowClick) {
        this.closeSelect();
      }
    },
    enter(el) {
      gsap.fromTo(el, { opacity: 0.6, height: "50%", duration: 0.2 }, { opacity: 1, height: "auto", duration: 0.2 });
    },
    leave(el, done) {
      let isDone = false;
      const finish = () => {
        if (!isDone) {
          isDone = true;
          done();
        }
      };

      el.style.pointerEvents = "none";
      gsap.killTweensOf(el);
      gsap.to(el, { opacity: 0.6, height: 0, duration: 0.1, onComplete: finish, onInterrupt: finish });
    },
    getOption(code) {
      console.log('getOption', code);
      if (this.keyt) {
        let val = "";
        this.keywords.forEach((e, i) => {
          if (e.code == code) {
            val = i;
            // console.log(e)
          }
        });
        return val;
      } else {
        let val = {};
        this.keywords.forEach((e) => {
          if (e.code == code) {
            if (e.place) {
              val.g = true;
            } else {
              val.g = false;
            }
            if(e.icon && this.toggleIcons) {
              val.icon = e.icon;
            }
            val.n = e.value || e.name;

            // Для currsP2P сохраняем все необходимые свойства
            if (this.currsP2P) {
              val.logo = e.logo;
              val.full_name = e.full_name;
              val.name = e.name;
              val.small_name = e.small_name;
              val.curr_text = e.curr_text;
              val.unit_abbreviation = e.unit_abbreviation;
            }

          }
        });
        return val;
      }
    },
    selectOption(value, repeat = false) {
      this.name = this.getOption(value);
      this.value = value;
      if (!repeat) {
        this.setValue(repeat);
      }

      /* если есть поиск, после выбора значения селекта поиск очищается
            метод clearSearchInput содержит проверку существования поиска */
      this.isSearch ? this.clearSearchInput() : "";
      this.closeSelect();
    },
    inputSearchHandler(event) {
      const searchValue = event.target.value;
      this.textInSearch = searchValue ? true : false;
      console.log('searhc keywords', this.keywords);
      const searchResult = this.keywords.filter((keyword) => {
      const searchValueLower = searchValue.toLowerCase();
      if (this.keyt) {
        return (keyword.name && keyword.name.toLowerCase().includes(searchValueLower)) ||
          (keyword.identifier && keyword.identifier.toLowerCase().includes(searchValueLower)) ||
          (keyword.curr && keyword.curr.toLowerCase().includes(searchValueLower)) ||
          (keyword.code && String(keyword.code).toLowerCase().includes(searchValueLower)) ||
          (keyword.keyt && keyword.keyt.toLowerCase().includes(searchValueLower) ||
          (keyword.value && keyword.value.toLowerCase().includes(searchValueLower)));
      }
      switch (this.searchType) {
          case "value":
            return keyword.value.toLowerCase().includes(searchValueLower);
          case "curr":
            return keyword.curr.toLowerCase().includes(searchValueLower);
          case "address":
            return keyword.name.toLowerCase().includes(searchValueLower);
          default:
            return false;
        }
      });
      this.optionsList = searchResult.length > 0 ? [...searchResult] : [];
    },
    clearFilterSelect() {
      this.name = "";
      if(this.id === 'done') {
        this.value = 'false'
      } else {
        this.value = "-1";
      }

      this.updateState();
    },
    _toggleModalOverflow(isOpen) {
      // Ищем ближайшую модалку. Если SelectSimple живёт не в модалке —
      // closest вернёт null и ничего не делаем.
      const modal = this.$el?.closest?.('.vue-modal-window');
      if (!modal) return;
      modal.classList.toggle('vue-modal-window--dropdown-open', isOpen);
    },
  },
};
</script>

<style lang="scss" scoped>
.invalid {
  border-color: $color-invalid-2 !important;
  padding-right: calc(1.5em + 0.75rem);
  background-image: none;
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 1.6rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  box-shadow: none;
}
.mh-ks {
  min-height: 40px;
  height: 40px;
  border-bottom: 1px solid var(--bs-border-color);
}
.select-thin {
  max-height: 38px;
}
.simp-bg {
  background-color: $color-href;
  border: 1px solid $color-href;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.input-container:focus:not(.disable) {
  box-shadow: 0;
}

.form-control {
  height: 40px;
}

.form-control-keyt {
  height: 56px;
  width: 100%;
  background-color: #fff;
}

.form-control-tall {
  height: 112px;
}

.input-container.disable,
.input-container.disable:focus,
.input-container.disable:focus-visible,
.input-container.disable:hover {
  border: 1px solid $primary-stroke;
  outline: none;
  box-shadow: none;
  cursor: default;
}

.input-search-wrapper {
  display: flex;
  padding-left: 30px;
  width: 100%;
  background-color: white;
  border: 1px solid $primary-stroke;
  border-radius: 12px;
  position: sticky;
  top: 0;
  left: 0;
  padding: 10px 12px;
  height: 40px;
}
.input-search {
  width: calc(100% - 20px);
  border: none;
}
.input-search:focus,
.input-search:focus-visible {
  border: none;
  outline: none;
}
.input-search::placeholder {
  color: #000 !important;
}
input:-ms-input-placeholder { /* Для Internet Explorer 10-11 */
  color: #000 !important;
}

input::-ms-input-placeholder { /* Для Microsoft Edge */
  color: #000 !important;
}

input::-webkit-input-placeholder { /* Для WebKit-браузеров (Chrome, Safari) */
  color: #000 !important;
}

input::-moz-placeholder { /* Для Firefox 4-18 */
  color: #000 !important;
}

input:-moz-placeholder { /* Для Firefox 19+ */
  color: #000 !important;
}
.disable {
  background-color: $bg-light-grey;
  cursor: default !important;
}
.acted {
  background-color: $color-light;
  font-family: HelveticaNeue bold;
}
.alter-col {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
}
.k-symbol {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-size: 1rem;
    line-height: 1rem;
    display: flex;
    align-items: center;
  }
}
.k_tr {
  padding: 0.375rem 0.75rem !important;
}
.input-container {
  padding: 0;
  position: relative;
  cursor: pointer;
  min-height: 40px;
  border: 1px solid $primary-stroke;
  border-radius: 8px;
  &.disable {
    .input-container-select-value {
      color: $primary-grey;
    }
  }
  &.backgroundless {
    background-color: inherit;
    border: 0;
    min-height: auto;
    height: auto;
    
    .input-container-select {
      padding: 0;
    }
    .input-container-select-options {
      top: 100% !important;
    }
  }

  .input-container-select-options {
    border-radius: 8px;
  }

  &-select {
    width: 100%;
    // z-index: 2000;
    outline: none;
    // border: none;
    padding: 10px;
    background: transparent;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: "HelveticaNeue roman";
    line-height: 20px;
    cursor: pointer;
    height: 100%;
    &-value {
      height: min-content;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &-options {
      padding: 0;
      border-bottom: 1px solid #ced4da;
      border-left: 1px solid #ced4da;
      border-right: 1px solid #ced4da;
      left: -0.06rem;
      right: -0.06rem;
      background: #fff;
      position: absolute;
      overflow: auto;
      max-height: 280px;
      z-index: 8100;
      margin: 0;
      list-style-type: none;
      font-family: "HelveticaNeue";
      color: black;
      // border-radius: 0 0 0.25rem 0.25rem;
      &-li {
        padding: 0.375rem 0.75rem;
        label {
          font-weight: normal;
          cursor: pointer;
        }
        & .option-balance > span {
          display: inline-block;
          min-width: 256px;
        }
      }
      &-li:hover {
        background-color: $bg-light-blue;
      }
    }
  }
  .keyt-name {
    white-space: nowrap;

    @media (max-width: 768px) {
      overflow: hidden;
      max-width: 100px;
      text-overflow: ellipsis;
    }
  }
  .lh-1 {
    line-height: 1;
  }
}

.open-up {
  transform: translateY(-100%);
  border-radius: 0.25rem;
  border-top: 1px solid #ced4da;
}

.open-left {
  right: 0;
  left: auto;
  border-radius: 0.25rem;
}

.open-up.open-left {
  right: 0;
  left: auto;
  transform: translateY(-101%);
}

.border-shadow {
  border: 1px solid $primary-stroke;
  border-radius: 8px;
  box-shadow: 2px 2px 4px rgba(0,0,0, 0.05);
}

.option-left-content {
  min-width: 50%;
  overflow: hidden;
}

.option-balance-container {
  flex: 1 1 55%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 16px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
}

.option-name {
  color: black;
  @media (max-width: 768px) {
    overflow: hidden;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    display: block;
  }
}

.keyt-options {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
  margin-top: 4px;
}

.list-search {
    padding: 10px;
}

.max-w-40 {
  max-width: 40%;
}

.grid-cols-2 {
  display: grid;
  grid-template-columns: auto 1fr;
}

.icon-left {
  position: relative;
  flex-shrink: 0;
}
</style>
